if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}



class ProductMediaGallery {
  constructor() {
    this.thumbnailsWrapper = document.querySelector('.product-media-gallery__thumbnails-wrapper');
    this.thumbnails = document.querySelectorAll('.product-media-gallery__thumbnail');
    this.slides = document.querySelectorAll('.product-media-gallery__slide');
    this.prevButton = document.querySelector('.thumbnails-nav--prev');
    this.nextButton = document.querySelector('.thumbnails-nav--next');
    
    if (this.thumbnails.length > 0) {
      this.init();
    }
  }
  
  init() {

  // Set initial active state
  const firstMediaId = this.thumbnails[0]?.dataset.mediaId;

  // Reset everything
  this.thumbnails.forEach(t => t.classList.remove('active'));
  this.slides.forEach(s => s.classList.remove('active'));

  // Activate first image only
  if (firstMediaId) {
    this.setActiveMedia(firstMediaId);
  }



    const activeThumbnail = document.querySelector('.product-media-gallery__thumbnail.active');
    if (!activeThumbnail && this.thumbnails.length > 0) {
      this.thumbnails[0].classList.add('active');

      const firstMediaId = this.thumbnails[0].dataset.mediaId;
      this.setActiveMedia(firstMediaId);
    }
    
    // Click handlers for thumbnails
    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => {
        const mediaId = thumbnail.dataset.mediaId;
        this.setActiveMedia(mediaId);
      });
    });
    
    // Navigation buttons
    this.prevButton?.addEventListener('click', () => {
      this.scrollThumbnails('up');
    });
    
    this.nextButton?.addEventListener('click', () => {
      this.scrollThumbnails('down');
    });
    
    // Update button states
    this.updateNavButtons();
    
    // Handle resize
    window.addEventListener('resize', () => {
      this.updateNavButtons();
    });
  }
  
  setActiveMedia(mediaId) {
    // Update thumbnails
    this.thumbnails.forEach(thumb => {
      thumb.classList.toggle('active', thumb.dataset.mediaId === mediaId);
    });
    
    // Update slides
    this.slides.forEach(slide => {
      slide.classList.toggle('active', slide.dataset.mediaId === mediaId);
    });
    
    // Ensure active thumbnail is visible
    const activeThumb = document.querySelector('.product-media-gallery__thumbnail.active');
    if (activeThumb) {
      this.scrollToThumbnail(activeThumb);
    }
    
    // Update nav buttons
    this.updateNavButtons();
  }
  
  scrollThumbnails(direction) {
    const scrollAmount = 90; // 80px thumbnail + 10px gap
    const currentScroll = this.thumbnailsWrapper.scrollTop;
    const maxScroll = this.thumbnailsWrapper.scrollHeight - this.thumbnailsWrapper.clientHeight;
    
    let targetScroll;
    if (direction === 'up') {
      targetScroll = Math.max(0, currentScroll - scrollAmount);
    } else {
      targetScroll = Math.min(maxScroll, currentScroll + scrollAmount);
    }
    
    this.thumbnailsWrapper.scrollTo({
      top: targetScroll,
      behavior: 'smooth'
    });
    
    // Update button states after scroll animation
    setTimeout(() => {
      this.updateNavButtons();
    }, 300);
  }
  
  scrollToThumbnail(thumbnail) {
    const thumbnailTop = thumbnail.offsetTop;
    const wrapperHeight = this.thumbnailsWrapper.clientHeight;
    const thumbnailHeight = thumbnail.offsetHeight;
    const currentScroll = this.thumbnailsWrapper.scrollTop;
    
    // Calculate if thumbnail is out of view
    if (thumbnailTop < currentScroll) {
      this.thumbnailsWrapper.scrollTo({
        top: thumbnailTop,
        behavior: 'smooth'
      });
    } else if (thumbnailTop + thumbnailHeight > currentScroll + wrapperHeight) {
      this.thumbnailsWrapper.scrollTo({
        top: thumbnailTop + thumbnailHeight - wrapperHeight,
        behavior: 'smooth'
      });
    }
  }
  
  updateNavButtons() {
    if (!this.thumbnailsWrapper) return;
    
    const scrollTop = this.thumbnailsWrapper.scrollTop;
    const maxScroll = this.thumbnailsWrapper.scrollHeight - this.thumbnailsWrapper.clientHeight;
    
    if (this.prevButton) {
      this.prevButton.disabled = scrollTop <= 0;
    }
    
    if (this.nextButton) {
      this.nextButton.disabled = scrollTop >= maxScroll - 1;
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.productMediaGallery = new ProductMediaGallery();
});

document.addEventListener('change', (event) => {
  setTimeout(() => {
    const selectedVariantEl = document.querySelector(
      'variant-selects script[type="application/json"], variant-radios script[type="application/json"]'
    );

    if (!selectedVariantEl) return;

    try {
      const variant = JSON.parse(selectedVariantEl.textContent);

      if (!variant?.featured_media?.id) return;

      window.productMediaGallery?.setActiveMedia(
        String(variant.featured_media.id)
      );
    } catch(e) {
      console.error(e);
    }
  }, 100);
});

// document.addEventListener('change', (event) => {
//   setTimeout(() => {
//     const selectedVariant = document.querySelector(
//       'variant-selects script[type="application/json"], variant-radios script[type="application/json"]'
//     );

//     if (!selectedVariant) return;

//     try {
//       const variants = JSON.parse(selectedVariant.textContent);

//       const selectedOption = document.querySelector(
//         'input[type="radio"]:checked, select'
//       );

//       if (!selectedOption) return;

//       const value = selectedOption.value;

//       const variant = variants.find(v =>
//         v.options && v.options.includes(value)
//       );

//       if (!variant?.featured_media?.id) return;

//       window.productMediaGallery?.setActiveMedia(
//         String(variant.featured_media.id)
//       );
//     } catch(e) {
//       console.error(e);
//     }
//   }, 100);
// });


// Re-initialize when variant changes
document.addEventListener('variantChange', () => {
  window.productMediaGallery = new ProductMediaGallery();
});